import { createToastInterface } from "vue-toastification";
const VueToast = {
  defaults: {
    position: "top-right",
    timeout: 5e3,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    closeButton: "button",
    icon: false,
    rtl: false
  },
  createToastInstance(_Vue, options) {
    const $toast = createToastInterface(options);
    _Vue.$toast = $toast;
    _Vue.prototype.$toast = $toast;
  },
  install(_Vue, config = {}) {
    const options = {};
    const self = this;
    Object.assign(options, this.defaults, config);
    _Vue.mixin({
      mounted() {
        if (this.$options.toast) {
          self.createToastInstance(_Vue, options);
        }
      }
    });
  }
};
export {
  VueToast as default
};
